// @flow

import { AccessTime } from "@mui/icons-material";
import { CardContent, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import dayjs from "dayjs";
import { useEffect, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import PageContentWrapper from "../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../components/mui/app/pageTitle/pageTitle";
import Card1 from "../../components/mui/general/cards/card1/card1";
import SkeletonLoaderWrapper from "../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import { access_check_lists_form } from "../../helpers/rights/rights";
import useCheckLists from "../../hooks/checkLists/useCheckLists";
import { CHECKLISTS } from "../../locales/pages/namespaces";
import { withPermissionHOC } from "../../modules/permission/components/permissionHOC/permissionHOC";
import Form from "./partials/form";

type Props = {};

const CheckList = (props: Props) => {
	const { t } = useTranslation(CHECKLISTS)
	const { loading, checkList, site } = useCheckLists()
	useEffect(() => {
		document.title = 'Καλώς Έχειν'
	}, [t])
	const formIsActive = useMemo(() => (checkList && Object.keys(checkList).length > 0), [checkList])
	// const monthName = dayjs().format('MMMM')
	// const year = dayjs().year()
	
	const date = checkList?.referenceDt ? dayjs(checkList?.referenceDt) : dayjs();
	const monthName = date.format('MMMM');
	const year = date.year();
	
	return (
		<SkeletonLoaderWrapper loading={loading}>
			<PageContentWrapper>
				<PageTitle
					sx={{ textAlign: 'center' }}
					title={<Box>Καλώς Έχειν - {monthName} {year} <br/>{site ? `${site}` : ''}</Box>} withDivider/>
				{/*<Form checkList={checkList}/>*/}
				{checkList && formIsActive ?
					(
						<Form checkList={checkList}/>
					) : (
						<Box
							display="flex"
							justifyContent="center"
							alignItems="center"
							mt={2}
							px={2}
						>
							<Card1>
								<CardContent>
									<AccessTime sx={{ fontSize: 48, color: "#6c63ff", mb: 1 }}/>
									<Typography variant="h5" gutterBottom>
										{t('form_message')}
									</Typography>
									<Trans
										i18nKey={'form_message_2'}
										ns={CHECKLISTS}>
										<Typography variant="body1" color="text.secondary">
											Form submission opens during the last week of each month.
											<br/>
											Please check back later to submit your response.
										</Typography>
									</Trans>
								
								</CardContent>
							</Card1>
						</Box>
					)
				}
			</PageContentWrapper>
		</SkeletonLoaderWrapper>
	);
}

export default withPermissionHOC(CheckList, [access_check_lists_form])